import { render, staticRenderFns } from "./overtime_edit.vue?vue&type=template&id=0854753a&scoped=true"
import script from "./overtime_edit.vue?vue&type=script&lang=js"
export * from "./overtime_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0854753a",
  null
  
)

export default component.exports